import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface AuthUser {
  id: string;
  email: string;
  fullName: string;
  telefono?: string;
  role: string;
  superAdmin?: boolean;
  organizacionId?: number;
  /** Sucursales asignadas (crm_usuario_sucursales). Vacío/undefined = sin restricción. */
  sucursalIds?: number[];
  /** Módulos habilitados por organización. Clave ausente/true = ON, false = OFF. */
  modulos?: Record<string, boolean>;
  /** Override de acceso por ruta/tarjeta para ESTE usuario puntual, por
   * encima de lo que su rol daría por defecto. true = forzado otorgado,
   * false = forzado denegado. Ausente = hereda del rol. */
  permisosOverride?: Record<string, boolean>;
  /** Delegación: puede gestionar usuarios/overrides de otros con el mismo
   * alcance que admin, aunque su rol no sea admin. */
  puedeGestionarPermisos?: boolean;
}

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  setSession: (s: { token: string; refreshToken: string; user: AuthUser }) => void;
  logout: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      user: null,
      setSession: (s) =>
        set({ token: s.token, refreshToken: s.refreshToken, user: s.user }),
      logout: () => set({ token: null, refreshToken: null, user: null }),
    }),
    { name: "crm-redesip-auth" },
  ),
);
